// @ts-ignore fix for @patsnap/common-ps-http
window.process = {
    env: {
        VUE_APP_DEPLOY_ENV: import.meta.env.VITE_DEPLOY_ENV,
        VUE_APP_PASSPORT_CLIENT_ID: import.meta.env.VITE_PASSPORT_CLIENT_ID,
        VUE_APP_PASSPORT_CLIENT_NAME: import.meta.env.VITE_PASSPORT_CLIENT_NAME,
        VUE_APP_ACCOUNT_SERVICE_URI: import.meta.env.VITE_ACCOUNT_SERVICE_URI,
        VUE_APP_PASSPORT_URI: import.meta.env.VITE_PASSPORT_URI,
        VUE_APP_EUREKA_SERVICE_URI: import.meta.env.VITE_EUREKA_SERVICE_URI,
        VUE_APP_CORE_BASIC_SERVICE_URI: import.meta.env.VITE_CORE_BASIC_SERVICE_URI,
        VUE_APP_STATIC_COMMON_URL: import.meta.env.VITE_STATIC_COMMON_URL,
        VUE_APP_GEETEST_MESSAGEAUTHENTICATION: import.meta.env.VITE_GEETEST_MESSAGEAUTHENTICATION,
        VUE_APP_EUREKA_SOCKET_URI: import.meta.env.VITE_EUREKA_SOCKET_URI,
    },
}
